module.exports = __webpack_public_path__ + "img/projectAdvantage-lazy.15ea7207.png";